/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const BarChart = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M3.5 2V20.5H22.25V22H2V2H3.5ZM7.75 12V19H6.25V12H7.75ZM11.75 8V19H10.25V8H11.75ZM15.75 10V19H14.25V10H15.75ZM19.75 5V19H18.25V5H19.75Z"
                        fill={color}
                    />
                </svg>
        );
    };
